import React, { Component } from "react";
import { Card, CardBody, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import ManagePublishedMealPlanTable from "../publishedMealPlans/ManagePublishedMealPlanTable";
import ManageDraftMealPlanTable from "../draftMealPlans/ManageDraftMealPlanTable";
class ManageAllMealPlans extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
        };
    }

    componentDidMount() {
        try {
            if (this.props && this.props.location) {
                if (this.props.location.state !== undefined) {
                    const { status } = this.props.location.state;
                    if (status === "draft") {
                        this.setState({ activeTab: "1" });
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    toggle = (tab) => {
        const { activeTab } = this.state;
        if (activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    };

    render() {
        const { activeTab } = this.state;

        return (
            <div>
                <Card>
                    <CardBody>
                        <Nav tabs className="mb-3">
                            {" "}
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "1" })}
                                    style={{
                                        // borderColor: " #1B415D #1B415D #fff ",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => this.toggle("1")}
                                >
                                    {"Draft Meal Plans "}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "2" })}
                                    style={{
                                        //borderColor: " #1B415D #1B415D #fff ",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => this.toggle("2")}
                                >
                                    {"Published Meal Plans "}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <ManageDraftMealPlanTable />
                            </TabPane>
                            <TabPane tabId="2">
                                <ManagePublishedMealPlanTable />
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default ManageAllMealPlans;
